import * as validator from 'vee-validate';

export default {
    components : { 'validation-observer' : validator.ValidationObserver },
    methods    : {
        setErrors (errors) {
            this.$refs.formValidator.setErrors(errors);
        }
    }
};
